import { Button } from '@/common/ui/button'
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '@/common/ui/dialog'
import { Trash2Icon } from 'lucide-react'
import { useState } from 'react'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { useQueryClient } from '@tanstack/react-query'
import useMutationDeleteEvent from '../../api/hooks/useMutationDeleteEvent'
import { EventsQueryKeys } from '../../keys'

interface DeleteEventModalProps {
	eventId: string
	eventTitle: string
}

export default function DeleteEventModal({
	eventId,
	eventTitle,
}: DeleteEventModalProps) {
	const [isOpen, setIsOpen] = useState(false)
	const queryClient = useQueryClient()

	const deleteEventMutation = useMutationDeleteEvent({
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [EventsQueryKeys.getEvents],
			})
			toast.success('ลบกิจกรรมสำเร็จ')
			setIsOpen(false)
		},
		onError: (error) => {
			showErrorToast(error)
		},
	})

	const handleDelete = () => {
		deleteEventMutation.mutate({ id: eventId })
	}

	return (
		<Dialog open={isOpen} onOpenChange={setIsOpen}>
			<DialogTrigger asChild>
				<Button variant="ghost" size="sm">
					<Trash2Icon className="h-4 w-4" />
				</Button>
			</DialogTrigger>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>ยืนยันการลบกิจกรรม</DialogTitle>
					<DialogDescription>
						คุณต้องการลบกิจกรรม &quot;{eventTitle}&quot; ใช่หรือไม่?
						<br />
						การดำเนินการนี้ไม่สามารถย้อนกลับได้
					</DialogDescription>
				</DialogHeader>
				<DialogFooter>
					<Button
						variant="outline"
						onClick={() => setIsOpen(false)}
						disabled={deleteEventMutation.isPending}
					>
						ยกเลิก
					</Button>
					<Button
						variant="destructive"
						onClick={handleDelete}
						disabled={deleteEventMutation.isPending}
					>
						{deleteEventMutation.isPending ? 'กำลังลบ...' : 'ลบกิจกรรม'}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}
